import { Container, Typography } from '@mui/material';
import { LetterSpacedHeading } from 'components/common';
import { OnePagerForm } from 'components/CreateOnePager/OnePagerForm';
import { MetaTags } from 'components/common';

const CreateOnePager = () => {
  return (
    <>
      <MetaTags
        title="Create One Pager"
        description="Create one pager for a startup fundraising campaign with this free one pager template. Give a high-level overview of your startup with this concise document."
        imageUrl={`${process.env.NEXT_PUBLIC_FRONTEND_URL}pod-logo.png`}
        url={process.env.NEXT_PUBLIC_FRONTEND_URL!}
        keywords="One Pager"
      />
      <Container>
        <LetterSpacedHeading sx={{ mt: '71px' }} component="h1">
          ONE PAGER
        </LetterSpacedHeading>
        <Typography
          marginY="20px"
          align="center"
          color="rgba(17, 17, 17, 0.7)"
          lineHeight="28px"
          fontWeight={300}
          maxWidth="600px"
          marginX="auto"
          fontSize={20}
        >
          Create and download your startup&apos;s One Pager to share with
          potential investors and have a smooth experience raising funds
        </Typography>
        <OnePagerForm />
      </Container>
    </>
  );
};

export default CreateOnePager;
